import { useContext } from "react";
import NavBarComp from "../../components/navbar/navbar";
import { CartContext } from "../../App";
import './contact.scss'
export interface ContactProps {

}

function Contact(props: ContactProps) {
    const cartContext = useContext(CartContext);

    return (
        <div className="contact">
            <NavBarComp active="contact" nCart={cartContext.cart ? cartContext.cart.items_count : 0}></NavBarComp>
            <div className="container">
                <div className="row mt-4">
                    <div className="col col-12">
                        <p className="intestazione">DOVE SIAMO</p>
                        <p><i className="bi bi-geo-alt"></i> Via Taurano, 116 | Pagani (SA)</p>
                        <p><i className="bi bi-telephone"></i> 081 515 1547</p>
                        <p><i className="bi bi-envelope"></i> anna.ferraiolo1987@gmail.com</p>
                        <p>P.IVA 04533270650</p>

                        <p className="mt-4">seguici su
                            <button className="btn p-1"><i className="bi bi-facebook" onClick={() => {
                                window.open(
                                    'https://www.facebook.com/cafeinoutpagani',
                                    '_blank'
                                )
                            }}></i></button>
                            <button className="btn p-1"><i className="bi bi-instagram"
                                onClick={() => {
                                    window.open(
                                        "https://www.instagram.com/inoutcafepagani/",
                                        '_blank'
                                    )
                                }}></i></button>
                        </p>
                        <p className="subtext">
                            Vuoi diventare un nostro rivenditore?
                            <br></br>
                            Inviaci una e-mail e ci metteremo in contatto a breve.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Contact